import constants from '@/constants';
import RequestAssigneeSummaryModel from '@/Models/requestAssigneeSummaryModel';

export default class AssigneeManager {
  static getAssignedPersonaId(selectedAssignee: RequestAssigneeSummaryModel | undefined | null): string | null {
    return selectedAssignee?.assigneeType === constants.requestAssigneeTypes.user ? selectedAssignee.id : null;
  }

  static getAssignedGroupId(selectedAssignee: RequestAssigneeSummaryModel | undefined | null): string | null {
    return selectedAssignee?.assigneeType === constants.requestAssigneeTypes.group ? selectedAssignee.id : null;
  }

  static groupHasRegisteredContact(selectedAssignee: RequestAssigneeSummaryModel | undefined | null) : boolean {
    return selectedAssignee?.assigneeType === constants.requestAssigneeTypes.group && !selectedAssignee?.isGroupContactActive;
  }
}
